/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {DeleteApplication} from '../model/request/application/deleteApplication.ts'
import {BaseService} from "./BaseService.ts";
import {UpdateApplication} from "../model/request/application/updateApplication.ts";
import {CreateApplication} from "../model/request/application/createApplication.ts";
import {ReadApplicationByWorkSpaceIdRequest} from "../model/request/application/ReadApplicationByWorkSpaceIdRequest.ts";

export class ApplicationService {
    static create = (others: any, data: CreateApplication) => {
        return BaseService.apiClient(others).post("/application/create", data);
    };

    static read = (others: any) => {
        return BaseService.apiClient(others).get("/application/read");
    };
    static readByWorkspaceId = (others: any, data: ReadApplicationByWorkSpaceIdRequest) => {
        return BaseService.apiClient(others).get(`/application/read-by-application-workspace-id/${data?.applicationWorkspaceId}`);
    };
    static delete = (others: any, data: DeleteApplication) => {
        return BaseService.apiClient(others).post("/application/delete", data);
    };
    static update = (others: any, data: UpdateApplication) => {
        return BaseService.apiClient(others).post("/application/update", data);
    };
}